import { FramingSelections } from '../../../components/Checkout/Framing/types';
import { GeneratedOrderItem } from '../../../types/generated';
import { buildFrameOptionalItems } from './orderItems';

type BuildDrawOptionalItemsArgs = {
  framingSelections: FramingSelections;
  productId: string | null;
};

export const buildDrawOptionalItems = ({
  framingSelections,
  productId,
}: BuildDrawOptionalItemsArgs): GeneratedOrderItem[] => {
  return buildFrameOptionalItems(
    productId ? framingSelections[productId] : undefined,
  );
};
